import Footer from "../components/Footer";

function About() {
  return (
    <div>
      <h1>About</h1>
      <Footer />
    </div>
  );
}

export default About;
